import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { StepEnum } from '../../constants/step.enum';
import { PreautorisationSelectors } from '../../state/preautorisation.selectors';
import { STEPS_CONFIG } from './flow.config';

@Injectable({
  providedIn: 'root'
})
export class FlowHelperService {
  constructor(private readonly store: Store) {}

  get nextStep() {
    const nextIndex = this.steps.indexOf(this.currentStep) + 1;
    return this.steps[nextIndex];
  }

  get previousStep() {
    const previousIndex = this.steps.indexOf(this.currentStep) - 1;
    return this.steps[previousIndex];
  }

  get isLastStep() {
    return this.nextStep === undefined;
  }

  get isFirstStep() {
    return this.previousStep === undefined;
  }

  get currentStepPosition() {
    return this.steps.indexOf(this.currentStep) + 1;
  }

  get totalSteps(): number {
    return this.steps.length;
  }

  get progressValue(): number {
    return Math.round(Math.max(0, (this.currentStepPosition / this.totalSteps) * 100));
  }

  get currentStep(): StepEnum {
    return this.store.selectSnapshot(PreautorisationSelectors.currentStep);
  }

  get steps(): StepEnum[] {
    return STEPS_CONFIG.filter(config => !config.conditions || this.store.selectSnapshot(config.conditions())).map(
      config => config.step
    );
  }
}
